import React, { useContext, useEffect, useState } from 'react';
import { Nav, Button } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useUserContext } from '../../user-context/UserContext';
import { PathContext } from '../../user-context/path-context/PathContext';
import "../../../../../../../_metronic/assets/keenicons/outline/style.css";

function AddEmployeeSubMenu() {
  const location = useLocation();
  const {pathname}=useLocation();
  const { currentUserId, setCurrentUserId } = useUserContext();
  const { isPathMatched, setIsPathMatched } = useContext(PathContext);
  const [shouldRerender, setShouldRerender] = useState(false);
  useEffect(() => {
    const userId = localStorage.getItem('current_user_id');
    setCurrentUserId(userId);
    // Trigger rerender if pathname is not equal to the specific path
    if (pathname !== '/hr/employee/add-employee/personal-details') {
      setShouldRerender(true);
    } else {
      setShouldRerender(false);
    }
  }, [setCurrentUserId, pathname]);

  const navigate = useNavigate();

  const handleBackToMenu = () => {
    localStorage.removeItem("pathMatched");
    navigate('/hr/employee/landing-page-employees'); // Navigate to the main employee menu (or any other desired path)
  };
  return (
    <div>
      <div>
        <Nav className="flex-column py-3">
          <Nav.Item className="px-3 nav-item-custom pb-2">
            {/* Button to go back to menu */}
            <Button onClick={handleBackToMenu} variant="light" className="w-100 mb-3">
              Back to Menu
            </Button>
          </Nav.Item>
          {/* Submenu */}
          <Nav className="flex-column ms-3">
          <Nav.Item className="px-3 nav-item-custom pb-2">
            <Nav.Link
              as={Link}
              to="/hr/employee/add-employee/personal-details"
              className={`d-flex align-items-center text-white ${location.pathname.startsWith('/hr/employee/add-employee') ? 'active fw-bold' : ''}`}
            >
                <span className='menu-icon'>
                  <i className="menu-icon-add-employee fs-5 fa fa-user-plus" />
                </span>
                <span className='menu-title-add-employee'> Personal Details </span>
              </Nav.Link>
            </Nav.Item>
            {[
              { path: 'contact-details', label: 'Contact Details', icon: 'fa fa-envelope' },
              { path: 'dependents', label: 'Dependents', icon: 'fa fa-users' },
              { path: 'immigration', label: 'Immigration', icon: 'fa fa-globe' },
              { path: 'job', label: 'Job', icon: 'fa fa-briefcase' },
              { path: 'salary', label: 'Salary', icon: 'fa fa-dollar-sign' },
              { path: 'report-to', label: 'Report-to', icon: 'fa fa-user-check' },
              { path: 'qualification-details', label: 'Qualifications', icon: 'fa fa-graduation-cap' },
              { path: 'bank-details', label: 'Bank Details', icon: 'fa fa-university' }
            ]
              .map((item) => (
                <Nav.Item className="px-3 nav-item-custom pb-2">
                  <Nav.Link
                    as={Link}
                    to={`/hr/employee/add-employee/${item.path}`}
                    key={item.path}
                    className={`d-flex align-items-center ${!currentUserId ? 'disabled-link' : 'menu-title-add-employee'} ${location.pathname === `/hr/employee/add-employee/${item.path}` ? 'active fw-bold' : ''}`}
                    disabled={!currentUserId} // Disable the link if no currentUserId
                    >
                  <span className='menu-icon'>
                  <i className={`${item.icon} ${!currentUserId ? 'menu-icon-add-employee-link' : 'menu-icon-add-employee'}  fs-5`} />
                  </span>
              <span className={`${!currentUserId ? 'menu-title-add-employee-active' : 'menu-title-add-employee'}`}>{item.label}</span>
              </Nav.Link>
              </Nav.Item>
            ))}
          </Nav>
        </Nav>
      </div>
    </div>
  );
}

export default AddEmployeeSubMenu;
